import React, { Fragment } from 'react';
import { Formik, Form, Field } from 'formik';

import styles from './userAccountShowPageStyles';

import Button, { BUTTON_TYPES, BUTTON_SIZES } from 'buyside/components/presentation/Button/button';
import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';

import CheckMarkIcon from 'buyside/svgs/check.svg';

class ChangeUserLogIn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editLayout: false,
      updateSuccessful: false
    };

    this.toggleEditLayout = this.toggleEditLayout.bind(this);
    this.setUpdateSuccessful = this.setUpdateSuccessful.bind(this);
  }

  toggleEditLayout(boolean) {
    // false: read layout (not editing), true: edit layout - 24 Apr 2019 TMA
    return this.setState({ editLayout: boolean });
  }

  setUpdateSuccessful(currentState) {
    return this.setState({ updateSuccessful: !currentState });
  }

  renderReadLayout() {
    const { label, userInfo, changeText, successMessage } = this.props;
    const { updateSuccessful } = this.state;
    return (
      <div>
        <div className={styles.label}>{label}</div>
        <table>
          <tbody>
            <tr>
              <th className={styles.firstColumn}>
                <strong className={styles.userInfo}>{userInfo}</strong>
              </th>
              <th>
                <button className={styles.buttonLink} onClick={() => this.toggleEditLayout(true)}>
                  {changeText}
                </button>
              </th>
            </tr>
          </tbody>
        </table>
        {updateSuccessful ? (
          <div className={styles.successMsg}>
            <CheckMarkIcon className={styles.checkIcon} />
            {successMessage}
          </div>
        ) : null}
      </div>
    );
  }

  renderEditLayout() {
    const { handleUpdate, handleError, formFields, buttonText, validationSchema } = this.props;
    return (
      <div>
        <Formik
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting, setErrors }) => {
            handleUpdate(values)
              .then(() => {
                setSubmitting(false);
                this.toggleEditLayout(false);
                this.setUpdateSuccessful(this.state.updateSuccessful);
                setTimeout(() => {
                  this.setUpdateSuccessful(this.state.updateSuccessful);
                }, 5000); // The message should be displayed temporarily - 22 Apr 2019 (TMA)
              })
              .catch(e => {
                setSubmitting(false);
                handleError(e, setErrors);
              });
          }}
        >
          {({ isSubmitting }) => (
            <div className={styles.formContainer}>
              <Form>
                {formFields.map(({ type, name, label, value }) => (
                  <div className={styles.inputArea} key={name}>
                    <Field
                      component={InputField}
                      type={type}
                      name={name}
                      label={label}
                      value={value}
                      customStyles={styles}
                    />
                  </div>
                ))}
                <div>
                  <Button
                    text={buttonText}
                    type={BUTTON_TYPES.PRIMARY}
                    size={BUTTON_SIZES.TINY}
                    disabled={isSubmitting}
                  />
                  <Button
                    text="Cancel"
                    type={BUTTON_TYPES.SECONDARY}
                    size={BUTTON_SIZES.TINY}
                    buttonType={BUTTON_TYPES.BUTTON}
                    onClick={() => this.toggleEditLayout(false)}
                  />
                </div>
              </Form>
            </div>
          )}
        </Formik>
      </div>
    );
  }

  render() {
    const { editLayout } = this.state;
    return <Fragment>{editLayout ? this.renderEditLayout() : this.renderReadLayout()}</Fragment>;
  }
}

export default ChangeUserLogIn;
